export default __webpack_public_path__ + "static/media/ic_avalanche_96.b6255c50.svg";